var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep232(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_1949)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.7266,
    r: 16,
    fill: "#F3FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.012 23H12.188V21.512L15.1 18.568C15.676 17.9813 16.1453 17.48 16.508 17.064C16.8813 16.6373 17.1533 16.2427 17.324 15.88C17.5053 15.5173 17.596 15.1227 17.596 14.696C17.596 14.1733 17.4467 13.784 17.148 13.528C16.8493 13.2613 16.4547 13.128 15.964 13.128C15.484 13.128 15.036 13.2293 14.62 13.432C14.204 13.624 13.772 13.9013 13.324 14.264L12.22 12.936C12.54 12.6587 12.8813 12.408 13.244 12.184C13.6067 11.9493 14.0173 11.7627 14.476 11.624C14.9347 11.4853 15.468 11.416 16.076 11.416C16.812 11.416 17.4413 11.5493 17.964 11.816C18.4973 12.072 18.908 12.4293 19.196 12.888C19.484 13.3467 19.628 13.88 19.628 14.488C19.628 14.9573 19.5587 15.3947 19.42 15.8C19.2813 16.1947 19.0787 16.584 18.812 16.968C18.5453 17.352 18.22 17.7413 17.836 18.136C17.452 18.5307 17.02 18.9573 16.54 19.416L14.732 21.16V21.256H20.012V23Z",
    fill: "#1778E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_1949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.726562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep232);
export default __webpack_public_path__ + "static/media/step-2-32.d5a62dd9.svg";
export { ForwardRef as ReactComponent };